/** Gameplay opts into a uniform scale and the same quality cap across rotation. */
export function renderResolution(
  cssWidth: number,
  cssHeight: number,
  resolutionScale: number,
  maximumDimension: number,
  responsive = false,
): { readonly width: number; readonly height: number } {
  if (!responsive) {
    // Preserve the established editor/inset canvas sizing exactly.
    let width = Math.max(320, Math.floor(cssWidth * resolutionScale));
    let height = Math.max(180, Math.floor(cssHeight * resolutionScale));
    if (width > maximumDimension) {
      const ratio = maximumDimension / width;
      height = Math.floor(height * ratio);
      width = maximumDimension;
    }
    return { width: width - width % 2, height: height - height % 2 };
  }
  const longEdge = Math.max(cssWidth, cssHeight);
  const shortEdge = Math.min(cssWidth, cssHeight);
  // Retain the existing minimum render budget without stretching one axis.
  const scale = Math.min(
    Math.max(resolutionScale, 320 / longEdge, 180 / shortEdge),
    maximumDimension / longEdge,
  );
  const evenPixels = (size: number): number => Math.max(2, Math.floor(size * scale / 2) * 2);
  return { width: evenPixels(cssWidth), height: evenPixels(cssHeight) };
}
